var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.827,13.452c.436.366.968.552,1.496.552.375,0,.747-.094,1.08-.281l9.424-4.688c.734-.426,1.173-1.188,1.173-2.037,0-.849-.439-1.609-1.229-2.065L13.448.301c-.848-.476-1.875-.381-2.621.247-.744.625-1.015,1.622-.66,2.617l1.735,3.835-1.767,3.914c-.324.916-.052,1.913.691,2.538Zm7.87-6.822l-5.162-.871-1.514-3.339c-.059-.168.018-.278.093-.342.044-.037.105-.072.188-.072.058,0,.127.017.21.062l9.31,4.625c.153.089.177.229.177.306s-.023.218-.12.276l-9.412,4.68c-.157.089-.278.029-.354-.033-.075-.063-.152-.174-.125-.263l1.547-3.418,5.161-.871c.404-.081.404-.659,0-.74Zm-8.697,16.37c0,.553-.448,1-1,1h-2c-.552,0-1-.447-1-1s.448-1,1-1h2c.552,0,1,.447,1,1Zm14-3c0,2.206-1.794,4-4,4h-7c-.552,0-1-.447-1-1s.448-1,1-1h7c1.103,0,2-.897,2-2s-.897-2-2-2H6c-3.309,0-6-2.691-6-6s2.691-6,6-6h2c.552,0,1,.447,1,1s-.448,1-1,1h-2c-2.206,0-4,1.794-4,4s1.794,4,4,4h14c2.206,0,4,1.794,4,4Zm-20,3c0,.553-.448,1-1,1H1c-.552,0-1-.447-1-1s.448-1,1-1h2c.552,0,1,.447,1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.b640cd9b4c7c994e3b124c1fbf320da2.svg";
export { ForwardRef as ReactComponent };